export function ifExistThen<S = any, T = any>(object: S, expr: T): T {
  return object == null ? (object as unknown as T) : expr;
}
